import { filter, get, includes, isEmpty, map, sortBy } from 'lodash'

const getComponentIngredientsTreeForId = (
  id,
  flattenedIngredientOptionsGroupedById,
  parentKey = '',
  alreadyFoundComponentIngredientIds = [],
) => {
  const componentIngredientsOfValueSortedByType = sortBy(
    get(flattenedIngredientOptionsGroupedById, `${id}[0].componentIngredients`),
    'type',
  )

  const componentIngredientsNotAlreadyFound = filter(
    componentIngredientsOfValueSortedByType,
    ({ id }) => !includes(alreadyFoundComponentIngredientIds, id),
  )

  const componentIngredientIdsNotAlreadyFound = map(
    componentIngredientsNotAlreadyFound,
    'id',
  )

  return map(
    componentIngredientsOfValueSortedByType,
    (componentIngredient, index) => {
      const key = isEmpty(parentKey) ? `${index}` : `${parentKey}-${index}`

      const ingredientTitle = get(
        flattenedIngredientOptionsGroupedById,
        `${componentIngredient.id}[0].title`,
      )

      const isComponentIngredientAlreadyInTree = !includes(
        alreadyFoundComponentIngredientIds,
        componentIngredient.id,
      )

      return {
        ...componentIngredient,
        title: ingredientTitle,
        key,
        parentId: id,
        children: isComponentIngredientAlreadyInTree
          ? getComponentIngredientsTreeForId(
              componentIngredient.id,
              flattenedIngredientOptionsGroupedById,
              key,
              [
                ...alreadyFoundComponentIngredientIds,
                ...componentIngredientIdsNotAlreadyFound,
              ],
            )
          : [],
      }
    },
  )
}

export default getComponentIngredientsTreeForId
